import { db } from "@/db";
import { notifications, poll, pollOption, pollVote } from "@/db/schema";
import { getUserSession } from "@/lib/api/auth.api";
import { auth } from "@/lib/better-auth/auth";
import { CreateVoteSchema } from "@/lib/zod-schemas/create-vote.schema";
import { redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { and, eq, sql } from "drizzle-orm";
import { v7 as uuidv7 } from "uuid";

// const createNotification = async (
//   pollId: string,
//   userId: string,
//   pollQuestion: string,
//   sessionToken: string,
// ) => {
//   const [existingNotification] = await db
//     .select()
//     .from(notifications)
//     .where(
//       and(
//         eq(notifications.userId, userId),
//         eq(notifications.entityId, pollId),
//         eq(notifications.type, 'vote'),
//       ),
//     );

//   if (existingNotification) {
//     await db
//       .update(notifications)
//       .set({
//         id: uuidv7(),
//         count: existingNotification.count + 1,
//         isRead: false,
//         updatedAt: new Date(),
//       })
//       .where(eq(notifications.id, existingNotification.id))
//       .returning();
//   } else {
//     await db.insert(notifications).values({
//       userId,
//       type: 'vote',
//       entityType: 'poll',
//       count: 1,
//       entityId: pollId,
//       metadata: { pollQuestion },
//     });
//   }

//   try {
//     const response = await fetch('http://localhost:3001/notify', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         session_token: sessionToken,
//         targetUserId: userId,
//       }),
//     });

//     if (!response.ok) {
//       console.error('user probably not connected');
//     }
//   } catch (error) {
//     console.error('error sending notification', error);
//   }
// };

export const createVote = createServerFn({
  method: "POST",
})
  .inputValidator(CreateVoteSchema)
  .handler(async (ctx) => {
    const request = getRequest();
    const userSession = await auth.api.getSession({ headers: request.headers });

    if (!userSession?.user) {
      throw redirect({
        to: "/sign-in",
      });
    }

    if (!userSession.user.countryCode || !userSession.user.gender) {
      throw Error("User must be onboarded");
    }

    const { pollId, optionId } = ctx.data;

    return await db.transaction(async (tx) => {
      const [existingVote] = await tx
        .select()
        .from(pollVote)
        .innerJoin(pollOption, eq(pollVote.optionId, pollOption.id))
        .where(
          and(
            eq(pollVote.userId, userSession.user.id),
            eq(pollOption.pollId, pollId)
          )
        )
        .execute();

      if (existingVote) {
        return existingVote.poll_vote;
      } else {
        const newVote = await tx
          .insert(pollVote)
          .values({
            userId: userSession.user.id,
            optionId,
          })
          .returning();

        await tx
          .update(poll)
          .set({ voteCount: sql`${poll.voteCount} + 1` })
          .where(eq(poll.id, pollId))
          .execute();

        // await createNotification(
        //   pollId,
        //   pollAuthorId,
        //   pollQuestion,
        //   auth.session.token,
        // );

        return newVote;
      }
    });
  });
